export default "__VITE_ASSET__921f2fdc__"